import { createContext } from "react";

export const TransactionSelectionContext = createContext<{
  selectedTransactionIds: Set<string>;
  cursorTransactionId: string | null;
  selectSingle: (index: number) => void;
  toggleSelect: (index: number) => void;
  selectRange: (toIndex: number) => void;
  deselectAll: () => void;
  setCursorTransactionId: (id: string | null) => void;
  focusTransactionAtIndex: (index: number) => void;
  transactionCount: number;
  /** Shared ref — set to true before focusing another row so its onFocus
   *  knows selection was already handled and doesn't override it. */
  selectionHandledRef: React.MutableRefObject<boolean>;
}>({
  selectedTransactionIds: new Set(),
  cursorTransactionId: null,
  selectSingle: () => {},
  toggleSelect: () => {},
  selectRange: () => {},
  deselectAll: () => {},
  setCursorTransactionId: () => {},
  focusTransactionAtIndex: () => {},
  transactionCount: 0,
  selectionHandledRef: { current: false },
});
